import React, { useState } from 'react';
import Slider from 'react-slick';
import loadable from '@loadable/component';
import { FILTER_TYPES, PRODUCT_VARIANT_ABBREVIATIONS } from '../../../shared/enums';
import { filterFeatureStatic } from '../../static-data';

const LazyImg = loadable(() => import('../common/LazyImg'));

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const NextArrow = props => {
  const { className, onClick } = props;

  return (
    <button type='button' className={`${className} filter-feature__slide-next`} onClick={onClick} aria-label='Go to Next slide'>
      <svg className='icon icon-circle-right-arrow'><use xlinkHref='#icon-circle-right-arrow' /></svg>
      <span className='screen-reader-text'>Go to Next slide</span>
    </button>
  );
};

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const PrevArrow = props => {
  const { className, onClick } = props;

  return (
    <button type='button' className={`${className} filter-feature__slide-prev`} onClick={onClick} aria-label='Go to previous slide'>
      <svg className='icon icon-circle-left-arrow'><use xlinkHref='#icon-circle-left-arrow' /></svg>
      <span className='screen-reader-text'>Go to previous slide</span>
    </button>
  );
};

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FilterFeatureSlider = ({
  settingsItems, sliderItems, prop4, asNavFor, setNav2,
}) => (
  <Slider
    {...settingsItems}
    asNavFor={asNavFor}
    ref={slider => setNav2(slider)}
    className='filter-feature__slider'
  >
    {sliderItems?.map(prop4)}
  </Slider>
);

/**
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const FilterFeatureImageSlider = ({
  settingsImages, sliderImages, prop4, setNav1, asNavFor,
}) => (
  <Slider
    {...settingsImages}
    asNavFor={asNavFor}
    ref={slider => setNav1(slider)}
    className='filter-feature__image-slider'
  >
    {sliderImages?.map(prop4)}
  </Slider>
);

/**
 * @param page
 * @param sliderImages
 * @param prop2
 * @returns {JSX.Element}
 * @constructor
 */
const FilterFeatureIconButton = ({ page, sliderImages, prop2 }) => (
  <div
    className={`filter-feature__icon-button filter-feature__icon-button--${FILTER_TYPES[page]}`}
  >
    {sliderImages?.map(prop2)}
  </div>
);

/**
 * @param page
 * @returns {JSX.Element}
 * @constructor
 */
const FilterFeature = ({ page }) => {
  const {
    sliderImages, sliderItems,
  } = filterFeatureStatic[page]
    || filterFeatureStatic[PRODUCT_VARIANT_ABBREVIATIONS.BASIC_BREATHER];

  const [ nav1, setNav1 ] = useState();
  const [ nav2, setNav2 ] = useState();

  const settingsImages = {
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    fade: true,
    speed: 1000,
    autoplay: false,
    autoplaySpeed: 2000,
    pauseOnHover: false,
    pauseOnFocus: false,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [{
      breakpoint: 767,
      settings: {
        arrows: false,
      },
    }],
  };

  const settingsItems = {
    dots: false,
    arrows: false,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '300px',
    pauseOnHover: false,
    pauseOnFocus: false,
    focusOnSelect: true,
    responsive: [{
      breakpoint: 1441,
      settings: {
        centerPadding: '200px',
      },
    }, {
      breakpoint: 767,
      settings: {
        dots: true,
        centerPadding: '100px',
      },
    }, {
      breakpoint: 500,
      settings: {
        dots: true,
        centerPadding: '50px',
      },
    }],
  };

  const iconClickHandle = (e, target) => {
    e.preventDefault();
    nav1.slickGoTo(target);
  };

  return (
    <div className='filter-feature'>
      <div className='container'>
        <div className='filter-feature__image-wrap'>
          <FilterFeatureImageSlider
            settingsImages={settingsImages}
            asNavFor={nav2}
            setNav1={setNav1}
            sliderImages={sliderImages}
            prop4={({
              src,
              alt,
            }) => (
              <div className='filter-feature__image-slide'>
                <LazyImg src={src} alt={alt} />
              </div>
            )}
          />
          <FilterFeatureIconButton
            page={page}
            sliderImages={sliderImages}
            prop2={({
              target,
              box,
            }) => (
              <button
                type='button'
                data-target={target}
                onClick={e => iconClickHandle(e, target)}
                className={`icon-box icon-box--${box}`}
                aria-label={`room location ${box}`}
              >
                <span className='screen-reader-text'>
                  {`room location ${box}`}
                </span>
              </button>
            )}
          />
        </div>
        <FilterFeatureSlider
          settingsItems={settingsItems}
          asNavFor={nav1}
          setNav2={setNav2}
          sliderItems={sliderItems}
          prop4={({
            title,
            text,
          }) => (
            <div className='filter-feature__slide'>
              <h3 className='filter-feature__slide-title'>{title}</h3>
              <p>
                {text}
              </p>
            </div>
          )}
        />
      </div>
    </div>
  );
};

export default FilterFeature;
